import path from "path";
import { pathToFileURL } from "url";

export async function loadSchemaFile(filePath: string) {
  const resolvedPath = path.resolve(filePath);

  try {
    // Handle .js files with CommonJS require()
    if (filePath.endsWith(".js")) {
      delete require.cache[require.resolve(resolvedPath)];
      return require(resolvedPath);
    }

    // Handle .ts files: auto-register ts-node if needed
    if (filePath.endsWith(".ts")) {
      try {
        require("ts-node").register({
          compilerOptions: {
            module: "commonjs",
            target: "es2020",
            esModuleInterop: true,
            allowSyntheticDefaultImports: true,
          },
        });
      } catch (e) {
        throw new Error(
          "TypeScript schema detected, but ts-node is not installed. Please install ts-node as a devDependency."
        );
      }
      // Use require for .ts files (not import)
      delete require.cache[require.resolve(resolvedPath)];
      return require(resolvedPath);
    }

    // Use dynamic import for .mjs, .cjs, etc.
    const module = await import(pathToFileURL(resolvedPath).href);
    return module.default || module;
  } catch (error) {
    throw new Error(
      `Failed to load schema file: ${
        error instanceof Error ? error.message : String(error)
      }`
    );
  }
}
